import { useState } from 'react';
import { ChevronRight as ChevronRightIcon } from 'lucide-react';
import { AnimatedCollapse } from '@reflex/ui/components/shared/AnimatedCollapse';
import { cn } from '@reflex/ui/lib/utils';

export function CollapsibleDetailRow({
  label,
  icon: Icon,
  count,
  noun,
  testId,
  children,
}: {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  count: number;
  noun: string;
  testId?: string;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <div className="flex items-baseline gap-2 text-sm" data-testid={testId}>
        <span className="w-24 shrink-0 text-muted-foreground">{label}</span>
        <button
          type="button"
          data-testid={testId ? `${testId}-toggle` : undefined}
          data-state={open ? 'open' : 'closed'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="group flex items-center gap-1 text-foreground/80 hover:text-foreground"
        >
          <Icon className="h-3.5 w-3.5 text-muted-foreground" />
          <span>
            {count} {noun}
            {count !== 1 ? 's' : ''}
          </span>
          <ChevronRightIcon
            className={cn(
              'h-3.5 w-3.5 text-muted-foreground transition-transform',
              open && 'rotate-90',
            )}
          />
        </button>
      </div>
      <AnimatedCollapse open={open}>
        <div className="ml-24 mt-1.5 space-y-1 pl-2">{children}</div>
      </AnimatedCollapse>
    </div>
  );
}
